import store from '../store'
import {MZCAPI} from '../helpers/http-mzcapi'
import MZLocation from '../models/MZLocation'
import MZLoyalty from '../models/MZLoyalty'
import MZCoupon from '../models/MZCoupon'
import configMixin from './configMixin'

/**
 * An interface for the mzCAPI - mzConnect API using Axios.
 * @author Jeff Wray <jwray@mobilozophy.com>
 * @moddate 2018-12-30
 */
export default {
  name: 'apiMixin',
  mixins: [configMixin],
  methods: {
    dataPull: function () {
      let _this = this
      return {
        getLoyaltyProgramRefresh: function (loyaltyId) {
          MZCAPI.get('/consumer/loyalty/' + loyaltyId, {
            headers: {
              Authorization: store.getters.getToken,
              MZScope: 'with-children'
            }})
            .then(function (response) {
              let loyaltyResponse = response.data.data
              MZLoyalty.insertOrUpdate({data: loyaltyResponse})
            })
        },
        getCouponRefresh: function (couponId) {
          MZCAPI.get('/consumer/coupons/' + couponId, {
            headers: {
              Authorization: store.getters.getToken,
              MZScope: 'with-children'
            }})
            .then(function (response) {
              let couponResponse = response.data.data
              MZCoupon.insertOrUpdate({data: couponResponse})
            })
        },
        getInitialData: function (coords) {
          console.log('get initial data called')
          if (coords && store.getters.getToken !== '' && (_this.$store.state.current_page <= _this.$store.state.total_pages)) {
            MZCAPI.get('/consumer/stores/' + coords.latitude + '/' + coords.longitude + '/from-profile', {
              headers: {
                Authorization: store.getters.getToken,
                MZScope: 'with-children',
                'x-mzaccount': _this.$store.getters.appConfig.api_account
              },
              params: {
                include: 'interestCategories,loyalty,coupons',
                page: _this.$store.state.current_page,
                per_page: 30
              }
            })
              .then(function (response) {
                let totalPages = response.data.meta.pagination.total_pages
                _this.$store.state.total_pages = totalPages

                if (response.data.data.length > 0) {
                  // _this.$store.state.current_page += 1
                  // Reducer Logic
                  let _mydata = response.data.data
                  let _myScrubData = []

                  _mydata.forEach(function (responseLocation) {
                    let data = {
                      id: responseLocation.id,
                      account_id: responseLocation.account_id,
                      account_name: responseLocation.account_name,
                      name: responseLocation.name,
                      store_number: responseLocation.store_number,
                      address1: responseLocation.address1,
                      address2: responseLocation.address2,
                      locality: responseLocation.locality,
                      region: responseLocation.region,
                      postalcode: responseLocation.postalcode,
                      country: responseLocation.country,
                      latitude: responseLocation.latitude,
                      longitude: responseLocation.longitude,
                      timezone: responseLocation.timezone,
                      meta_data: responseLocation.meta_data,
                      phone_number: responseLocation.phone_number,
                      distance: responseLocation.distance,
                      image: responseLocation.image,
                      directory_list_locations: responseLocation.directory_list_locations,
                      beacon_region_id: responseLocation.beacon_region_id,
                      interestCategories: responseLocation.interestCategories,
                      coupons: responseLocation.coupons.data,
                      loyalty: responseLocation.loyalty.data
                    }
                    _myScrubData.push(data)
                  })

                  MZLocation.insert({
                    data: _myScrubData
                  })
                  if (_this.$store.state.current_page < _this.$store.state.total_pages) {
                    // We don't want to go over the amount of pages
                    _this.$store.state.current_page += 1
                  }
                } else {
                }
              })
          }
        },
        infiniteHandler: function ($state) {
          console.log('infiniteHandler Called - apiMixin.js')
          MZCAPI.get('/consumer/stores/' + _this.$store.state.coords.latitude + '/' + _this.$store.state.coords.longitude + '/from-profile', {
            headers: {
              Authorization: store.getters.getToken,
              MZScope: 'with-children',
              'x-mzaccount': _this.$store.getters.appConfig.api_account
            },
            params: {
              include: 'interestCategories,loyalty,coupons',
              page: _this.$store.state.current_page,
              per_page: 30
            }
          })
            .then(function (response) {
              if (response.data.data.length > 0) {
                // _this.$store.state.current_page += 1
                // Reducer Logic
                let _mydata = response.data.data
                let _myScrubData = []

                _mydata.forEach(function (responseLocation) {
                  let data = {
                    id: responseLocation.id,
                    account_id: responseLocation.account_id,
                    account_name: responseLocation.account_name,
                    name: responseLocation.name,
                    store_number: responseLocation.store_number,
                    address1: responseLocation.address1,
                    address2: responseLocation.address2,
                    locality: responseLocation.locality,
                    region: responseLocation.region,
                    postalcode: responseLocation.postalcode,
                    country: responseLocation.country,
                    latitude: responseLocation.latitude,
                    longitude: responseLocation.longitude,
                    timezone: responseLocation.timezone,
                    meta_data: responseLocation.meta_data,
                    phone_number: responseLocation.phone_number,
                    distance: responseLocation.distance,
                    image: responseLocation.image,
                    directory_list_locations: responseLocation.directory_list_locations,
                    beacon_region_id: responseLocation.beacon_region_id,
                    interestCategories: responseLocation.interestCategories,
                    coupons: responseLocation.coupons.data,
                    loyalty: responseLocation.loyalty.data
                  }
                  _myScrubData.push(data)
                })

                MZLocation.insert({
                  data: _myScrubData
                })
                _this.$store.state.current_page += 1
                $state.loaded()
              } else {
                $state.complete()
              }
            })
        },
        updateLoyaltyItem: function ($state, id) {

        },
        updateCouponItem: function (state, id) {

        }
      }
    },
    redemption: function () {
      return {
        transactGeneral: function (code) {
          return MZCAPI.post('/consumer/scan/' + code, null, {
            headers: {
              Authorization: store.getters.getToken,
              MZScope: 'with-children'
            }
          })
        },
        transactTakeoutLoyalty: function (code) {
          return MZCAPI.post('/consumer/scan-takeout-loyalty/' + code, null, {
            headers: {
              Authorization: store.getters.getToken,
              MZScope: 'with-children'
            }
          })
        },
        transactLoyaltyRedeem: function (storeId, loyaltyId) {
          return MZCAPI.post('/consumer/redeem/' + loyaltyId + '/' + storeId, null, {
            headers: {
              Authorization: store.getters.getToken,
              MZScope: 'with-children'
            }
          })
        },
        transactEarnLoyaltyQr: function (code) {
          return MZCAPI.post('/consumer/scan-qr/loyalty-receipt', {
            payload: code
          }, {
            headers: {
              Authorization: store.getters.getToken,
              MZScope: 'with-children'
            }
          })
        },
        transactCouponRedeem: function (code, couponId) {
          return MZCAPI.post('/consumer/scan/' + code + '/coupon/' + couponId, null, {
            headers: {
              Authorization: store.getters.getToken,
              MZScope: 'with-children'
            }
          })
        },
        transactSelfCouponRedemption: function (locationId, couponId) {
          return new Promise((resolve, reject) => {
            MZCAPI.post('/consumer/self-redeem/' + locationId + '/coupon/' + couponId, null, {
              headers: {
                Authorization: store.getters.getToken,
                MZScope: 'with-children'
              }
            }).then(function (response) {
              console.log('Response from transactSelfCouponRedemption API call:', response)
              resolve(response)
            }
            )
          })
        }
      }
    },
    createSubscriptionIntent () {
      return MZCAPI.get('/consumer/payments/stripe-setup-intent', {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    createSubscription (name, plan) {
      return MZCAPI.post(`/consumer/payments/subscriptions/${name}/${plan}`, null, {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    updateCard (paymentMethodId) {
      return MZCAPI.put('/consumer/payments/cards', {
        token: paymentMethodId
      }, {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    getSubscriptions () {
      return MZCAPI.get('/consumer/payments/subscriptions', {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    getProductPurchaseStatus (productId) {
      return MZCAPI.get(`/consumer/payments/products/${productId}`, {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    executePurchase (product, paymentMethod) {
      return MZCAPI.post(`/consumer/payments/products/${product.id}`, {
        payment: paymentMethod
      }, {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    executePurchaseRedemption (product, redemptionCode) {
      return MZCAPI.post(`/consumer/payments/products/${product.id}`, {
        code: redemptionCode
      }, {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    getStoreCategories () {
      let isLoggedIn = store.getters.isLoggedIn
      if (isLoggedIn) {
        return MZCAPI.get('/consumer/stores/categories', {
          headers: {
            Authorization: store.getters.getToken,
            MZScope: 'with-children'
          }
        })
      } else {
        return MZCAPI.get('/consumer/public/stores/categories', {
          params: {
            account_id: this.appConfig.api_account
          }
        })
      }
    },
    getStoresForCategory (categoryId) {
      let isLoggedIn = store.getters.isLoggedIn
      if (isLoggedIn) {
        return MZCAPI.get(`/consumer/stores-by-category-id/${categoryId}`, {
          headers: {
            Authorization: store.getters.getToken,
            MZScope: 'with-children'
          }
        })
      } else {
        return MZCAPI.get(`/consumer/public/stores-by-category-id/${categoryId}`, {
          params: {
            account_id: this.appConfig.api_account
          }
        })
      }
    },
    // E-Gift Cards
    locateUserByEmail (email) {
      return MZCAPI.post(`/consumer/locate-user-by-email`, {
        'email': email
      }, {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    buyGiftCard (payload) {
      return MZCAPI.post(`/consumer/gift-cards/buy`, payload, {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    acceptGiftCard (giftCardId) {
      return MZCAPI.post(`/consumer/gift-cards/${giftCardId}/accept`, {}, {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    getGiftCard (giftCardId) {
      return MZCAPI.get(`/consumer/gift-cards/${giftCardId}`, {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    redeemGiftCard (giftCardId) {
      return MZCAPI.post(`/consumer/gift-cards/${giftCardId}/redeem`, {}, {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    getGivenGiftCards () {
      return MZCAPI.get('/consumer/gift-cards', {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    getReceivedGiftCards () {
      return MZCAPI.get('/consumer/gift-cards/received', {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    getLoyaltyGiftCardProgram () {
      return MZCAPI.get('/consumer/loyalty/' + this.appConfig.egiftCardLoyalty + '?include=transactions', {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    getGiftCardRedemptions () {
      return MZCAPI.get('/consumer/gift-cards/spent', {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children'
        }
      })
    },
    runFullTextSearch (term, coords) {
      return MZCAPI.get(`/consumer/search/full-text/${term}?include=stores&lat=${coords.latitude}&lon=${coords.longitude}`, {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children',
          'x-mzaccount': store.getters.appConfig.api_account
        }
      })
    },
    runFuzzySearch (term, coords) {
      return MZCAPI.get(`/consumer/search/fuzzy/${term}?include=stores&lat=${coords.latitude}&lon=${coords.longitude}`, {
        headers: {
          Authorization: store.getters.getToken,
          MZScope: 'with-children',
          'x-mzaccount': store.getters.appConfig.api_account
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/apiMixin.js